module.exports = __webpack_public_path__ + "static/the-vital-question-31788b4349a5bfd31ecb3dad03c6411c.jpg";